const DEBUG = false;

const log = (componentName: string) => {
  // eslint-disable-next-line
  if (DEBUG) console.warn(`Render called for ${componentName}`);
};

export default log;
